import { getUserPreferences } from '@/composables/useUserPreferences';
import { parseUserDate, userDatePattern } from '@/util/userDate';

export function formatTableDate(value: string | number | Date | null | undefined, includeWeekday = true): string {
	if (value == null || value === '') return '';
	const settings = getUserPreferences();
	const format = userDatePattern(settings.dateFormat);
	const date = parseUserDate(value, settings.dateFormat);
	if (!date.isValid()) return String(value);
	return date.format(`${includeWeekday && settings.showDayOfWeek ? 'ddd, ' : ''}${format}`);
}

export function formatTableWeekday(value: string | number | Date | null | undefined): string {
	const settings = getUserPreferences();
	if (!settings.showDayOfWeek || value == null || value === '') return '';
	const date = parseUserDate(value, settings.dateFormat);
	return date.isValid() ? date.format('dddd') : '';
}

export function tableWeekday(): 'short' | undefined {
	return getUserPreferences().showDayOfWeek ? 'short' : undefined;
}

const ZONELESS_DATE_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/;

/**
 * Formats a timestamp for a table. API timestamps without an offset are UTC;
 * add that offset before parsing so they do not depend on the browser's zone.
 */
export function formatTableDateTime(value: string | number | Date | null | undefined, timeZone?: string): string {
	if (value == null || value === '') return '';
	const normalizedValue = typeof value === 'string' && ZONELESS_DATE_TIME.test(value) ? `${value}Z` : value;
	const date = new Date(normalizedValue);
	if (Number.isNaN(date.getTime())) return String(value);
	return date.toLocaleString(undefined, { timeZone, weekday: tableWeekday(), year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit', second: '2-digit' });
}
